import { render, staticRenderFns } from "./provider.vue?vue&type=template&id=1377be42&scoped=true&"
import script from "./provider.vue?vue&type=script&lang=js&"
export * from "./provider.vue?vue&type=script&lang=js&"
import style0 from "./provider.vue?vue&type=style&index=0&id=1377be42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377be42",
  null
  
)

export default component.exports